var map = {
	"./01-chs.png": 362,
	"./01-cht.png": 363,
	"./01-kor.png": 364,
	"./01-usa.png": 365,
	"./02-chs.png": 366,
	"./02-cht.png": 367,
	"./02-kor.png": 368,
	"./02-usa.png": 369,
	"./03-chs.png": 370,
	"./03-cht.png": 371,
	"./03-kor.png": 372,
	"./03-usa.png": 373,
	"./04-chs.png": 374,
	"./04-cht.png": 375,
	"./04-kor.png": 376,
	"./04-usa.png": 377,
	"./05-chs.png": 378,
	"./05-cht.png": 379,
	"./05-kor.png": 380,
	"./05-usa.png": 381,
	"./06-chs.png": 382,
	"./06-cht.png": 383,
	"./06-kor.png": 384,
	"./06-usa.png": 385,
	"./07-chs.png": 386,
	"./07-cht.png": 387,
	"./07-kor.png": 388,
	"./07-usa.png": 389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 361;